import AttributeTypeInfo from './AttributeTypeInfo';

export default AttributeTypeInfo;
